import { User } from '../crawler/crawler.interface';

export interface PrivateRouteProps {
    user: User;
    children: any; // eslint-disable-line 
}
export const PrivateRoute = ({ user, children }: PrivateRouteProps) => {

    if (!user.email) {
        const location = window.location.href;
        window.location.href = `${import.meta.env.VITE_BASE_PL_URL}/login?next=${location}`;
    }
    return children;
};

